function YourCompletedOrdersIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="12" fill="#7953D2" fillOpacity="0.2" />
      <path
        d="M12 18.666V11.9993M11.3333 18.486C11.536 18.603 11.766 18.6646 12 18.6646C12.234 18.6646 12.464 18.603 12.6667 18.486L17.3333 15.8193C17.5358 15.7024 17.704 15.5343 17.821 15.3318C17.938 15.1294 17.9998 14.8998 18 14.666V9.33262C17.9998 9.0988 17.938 8.86916 17.821 8.66673C17.704 8.46429 17.5358 8.29619 17.3333 8.17928L12.6667 5.51262C12.464 5.39559 12.234 5.33398 12 5.33398C11.766 5.33398 11.536 5.39559 11.3333 5.51262L6.66667 8.17928C6.46418 8.29619 6.29599 8.46429 6.17897 8.66673C6.06196 8.86916 6.00024 9.0988 6 9.33262V14.666C6.00024 14.8998 6.06196 15.1294 6.17897 15.3318C6.29599 15.5343 6.46418 15.7024 6.66667 15.8193L11.3333 18.486Z"
        stroke="#492897"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.19336 8.6657L12 11.999L17.8067 8.6657M9.00003 6.8457L15 10.279"
        stroke="#492897"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default YourCompletedOrdersIcon;
